import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";


export interface iGrantAdminState {
    email: string;
    isLoading: boolean;
    response: any;
    message: string;
}

const initialState: iGrantAdminState = {
    email: '',
    isLoading: false,
    response: [],
    message: ""
}

export const postGrantAdminAPI = createAsyncThunk(
    'POST_GRANT_ADMIN',
    async (user: { email: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/grant-admin/'
           

            const response = await axiosInstance.patch(
                `${djangoEndpoint}${pathParam}`,
                {
                    email: user.email,
                },
                {
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const grantAdminSlice = createSlice({
    name: 'grantAdmin',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postGrantAdminAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(postGrantAdminAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(postGrantAdminAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.email = '';
                state.response = action.payload;
            });
    }
});

export default grantAdminSlice.reducer;